'use es6';

import quickFetch from 'quick-fetch';
import * as StorefrontCollection from '../constants/StorefrontCollection';
export const maybeEarlyRequest = (requestName, requestCb) => {
  const earlyRequest = requestName && quickFetch.getRequestStateByName(requestName);

  if (earlyRequest) {
    const earlyRequestPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(() => {
        // retry the request
        requestCb().then(resolve).catch(err => {
          reject(err);
        });
        quickFetch.removeEarlyRequest(requestName);
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute(`${requestName}-early-request-used`, Boolean(earlyRequest.finished));
    }

    return earlyRequestPromise;
  }

  return requestCb();
};
export const getAllCollectionsEarlyRequestName = collection => {
  const base = 'all-collections';
  if (!collection) return base; // TODO early requests for other collections

  switch (collection) {
    case StorefrontCollection.POPULAR:
      return `${base}-popular`;

    case StorefrontCollection.NEW:
      return `${base}-new`;

    case StorefrontCollection.FREE:
      return `${base}-free`;

    default:
      return null;
  }
};